import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./css/App.css";
import "./css/menu-card.css";
import { Navbar } from "./components/Navbar";
import { SubNavProvider } from "./components/nav/SubNavContext";
import { Footer } from "./components/Footer";
import { Outlet } from "react-router-dom";
import { useMenu } from "./context/MenuContext";
import { trackPageview } from "./api";

// Public routes we report pageviews for. Mirrors the server-side allowlist
// so we don't burn requests on routes the backend would discard.
const TRACKED_PUBLIC_ROUTES = new Set([
  "/", "/menu", "/reserve", "/contact", "/gallery",
  "/giftcards", "/order", "/checkout", "/FAQ", "/deals", "/res",
]);

function normalizeForTracking(pathname) {
  if (typeof pathname !== "string" || !pathname.startsWith("/")) return null;
  let path = pathname;
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  if (path === "/home") path = "/"; // same page, two URLs
  if (path.startsWith("/res/")) path = "/res";
  if (path.startsWith("/reserve/")) path = "/reserve";
  return TRACKED_PUBLIC_ROUTES.has(path) ? path : null;
}

function App() {
  const location = useLocation();
  const { getMenu } = useMenu();

  useEffect(() => {
    const isOrderPath =
      location.pathname === "/order" ||
      location.pathname.startsWith("/order?item=");

    if (!isOrderPath) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const lastTrackedRoute = useRef(null);
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    const route = normalizeForTracking(location.pathname);
    if (!route || route === lastTrackedRoute.current) return;
    lastTrackedRoute.current = route;
    trackPageview(route);
  }, [location.pathname]);

  useEffect(() => {
    getMenu();
    // eslint-disable-next-line
  }, []);

  const blackList = [
    "/dashboard",
    {
      /** "/home" **/
    },
  ];

  const showSiteWideElements = !blackList.includes(window.location.pathname);

  return (
    <SubNavProvider>
      <div className="app">
        {showSiteWideElements && <Navbar />}
        {/** <Book/> **/}
        <Outlet />
        {showSiteWideElements && <Footer />}
      </div>
    </SubNavProvider>
  );
}

export default App;
